module.exports = "<i ng-class=\"icon.classList\"></i>"